import { makeStyles } from '@mui/styles';
import React from 'react';

import EditorSubForm from './ssEditorSubForm';
import { FCM_BORDER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles({
  changesModeWrapper: {
    marginBottom: 16,
    padding: 8,
    border: FCM_BORDER_STYLES.GREEN,
  },
  title: {
    fontWeight: 600,
  },
});

const SSSubForm = (props) => {
  const classes = useStyles();

  const { isEditor, children, isControlAddedFCM, formName, id } = props;

  if (isEditor) {
    return <EditorSubForm {...props} />;
  }

  if (isControlAddedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={id}>
        <div className={classes.title}>{formName}</div>
        {children}
      </div>
    );
  }

  return children;
};

export default SSSubForm;
